<div class="tsd_container service-form-dialog">
  <mat-card>
    <form [formGroup]="serviceForm">
      <mat-card-content>
        <h4>{{ id ? 'Edit Service' : 'Add Service' }}</h4>
        <div class="form-row">
          <mat-form-field class="service-code">
            <mat-label>Service Code</mat-label>
            <input matInput formControlName="serviceCode" autocomplete="off" (blur)="checkDuplicate('serviceCode.equals', 'serviceCode')" />
            @if (serviceForm.get('serviceCode')?.hasError('required')) {
              <mat-error>
                Service Code is required
              </mat-error>
            }
            @if (serviceForm.get('serviceCode')?.hasError('maxlength')) {
              <mat-error>
                Service Code cannot exceed 10 characters
              </mat-error>
            }
            @if (serviceForm.get('serviceCode')?.hasError('pattern')) {
              <mat-error>
                Service Code accepts alphanumeric values only
              </mat-error>
            }
            @if (serviceForm.get('serviceCode')?.hasError('duplicate')) {
              <mat-error>
                Service Code already exists
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="service-desc">
            <mat-label>Service Description</mat-label>
            <input matInput formControlName="serviceDescription" autocomplete="off" (blur)="checkDuplicate('serviceDescription.equals', 'serviceDescription')" />
            @if (serviceForm.get('serviceDescription')?.hasError('required')) {
              <mat-error>
                Service Description is required
              </mat-error>
            }
            @if (serviceForm.get('serviceDescription')?.hasError('maxlength')) {
              <mat-error>
                Service Description cannot exceed 100 characters
              </mat-error>
            }
            @if (serviceForm.get('serviceDescription')?.hasError('pattern')) {
              <mat-error>
                Service Description accepts alphanumeric values only
              </mat-error>
            }
            @if (serviceForm.get('serviceDescription')?.hasError('duplicate')) {
              <mat-error>
                Service Description already exists
              </mat-error>
            }
          </mat-form-field>
        </div>
        <mat-card-actions>
          <button type="button" mat-button color="cancel" (click)="cancel()">CANCEL</button>
          @if ((!id && addPermission) || (id && editPermission)) {
            <button type="button" mat-button color="primary" (click)="onSave()"
              >
              SAVE
            </button>
          }
        </mat-card-actions>
      </mat-card-content>
    </form>
  </mat-card>
</div>